<div
  class="container"
  style="display: flex; justify-content: center; align-items: center; height: 600px"
>
  <div style="max-width: 600px; width: 100%">
    <h2>Which option matches your service ability:</h2>
    <div
      style="
        display: grid;
        grid-gap: 10px;
        grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
      "
    >
      <div
        *ngFor="let signupType of signupTypes"
        (click)="selectedSignupType = signupType.id"
        [class.typeSelected]="signupType.id == selectedSignupType"
        style="
          text-align: center;
          box-sizing: border-box;
          padding: 20px;
          border-radius: 20px;
          border: 4px solid steelblue;
        "
      >
        <i
          class="fa"
          [class.fa-car]="signupType.id == 1"
          [class.fa-users]="signupType.id == 2"
          style="font-size: 50px"
        ></i>
        <div class="label">{{ signupType.name }}</div>
        <div style="max-width: 300px; padding-top: 40px">{{ signupType.description }}</div>
      </div>
    </div>
    <div style="text-align: right; padding-top: 15px">
      <button
        pButton
        type="button"
        ngClass="ui-button ui-button-primary"
        label="Continue"
        [disabled]="selectedSignupType == null"
        icon="fa fa-chevron-circle-right"
        (click)="onContinue()"
      ></button>
    </div>
  </div>
</div>
